import actionName from "../action-creator";
import { types } from "./virtual-tryon.actions";

const VIRTUAL_TRYON = `[VIRTUAL_TRYON]`;

const initialState = null;

function virtualTryOnReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case actionName(VIRTUAL_TRYON, types.SET):
            return payload;
        case actionName(VIRTUAL_TRYON, types.RESTORE_INITIAL):
            return initialState;
        default:
            return state;
    }   
}

export { initialState, VIRTUAL_TRYON };
export default virtualTryOnReducer;
